{
  "auth.common.back_to_login": "Back to sign in",
  "auth.common.email": "Email",
  "auth.common.password_guidance": "Use at least 12 characters and choose a long password only you know.",
  "auth.forgot.cooldown": "To request another link, try again in {seconds} seconds.",
  "auth.forgot.description": "Enter your sign-in email. The result is identical whether or not the account exists.",
  "auth.forgot.error": "Password recovery is temporarily unavailable. Try again later.",
  "auth.forgot.heading": "Recover your password",
  "auth.forgot.submit": "Send reset instructions",
  "auth.forgot.success": "Request accepted",
  "auth.forgot.success_description": "If the account exists, reset instructions will be sent through the configured secure channel.",
  "auth.login.account": "Account",
  "auth.login.description": "Use your organization account to securely access the admin console.",
  "auth.login.error.invalid": "The account or password is incorrect",
  "auth.login.error.service": "Sign-in is temporarily unavailable. Try again later.",
  "auth.login.forgot": "Forgot password?",
  "auth.login.heading": "Sign in to AppKernia",
  "auth.login.password": "Password",
  "auth.login.register": "Create account",
  "auth.login.register_prompt": "Need an account?",
  "auth.login.security": "Protected enterprise administration",
  "auth.login.submit": "Sign in",
  "auth.register.confirm_password": "Confirm password",
  "auth.register.description": "Create an account in the workspace configured by the administrator.",
  "auth.register.display_name": "Display name",
  "auth.register.error": "Account creation is temporarily unavailable. Try again later.",
  "auth.register.heading": "Create an account",
  "auth.register.mismatch": "The passwords do not match.",
  "auth.register.password": "Password",
  "auth.register.submit": "Create account",
  "auth.register.success": "Registration request accepted",
  "auth.register.success_description": "You can now return to sign in. To protect account privacy, this page does not reveal whether the email already existed.",
  "auth.register.terms": "I have read and agree to this workspace's terms of use and privacy rules.",
  "auth.register.terms_required": "Agree to the terms of use and privacy rules first.",
  "auth.reset.confirm_password": "Confirm new password",
  "auth.reset.description": "Setting a new password revokes every existing sign-in session for this account.",
  "auth.reset.error": "The password could not be reset. Try again later.",
  "auth.reset.heading": "Reset your password",
  "auth.reset.invalid": "The reset link is invalid or has expired. Request a new one.",
  "auth.reset.mismatch": "The new passwords do not match.",
  "auth.reset.new_password": "New password",
  "auth.reset.submit": "Reset password",
  "auth.reset.success": "Password reset",
  "auth.reset.success_description": "All old sessions have been revoked. Sign in with your new password.",
  "auth.unavailable.description": "This feature is not enabled. Contact your administrator."
}
